module.exports = __webpack_public_path__ + "static/media/leaderboard.f006850d.png";